<div class="min-h-screen flex flex-col bg-gradient-to-b from-cyan-50 via-cyan-100 to-cyan-200">
  <!-- Header -->
  <header class="w-full bg-white border-b border-gray-200">
    <div class="max-w-5xl mx-auto px-6 py-4 flex items-center gap-4">
      <img src="content/images/logo-regione.png" alt="Regione Toscana" class="h-16 shrink-0" />
      <div class="w-px h-10 bg-gray-200 mx-2"></div>
      <img src="content/images/Picture2.png" alt="Servizio Sanitario della Toscana" class="h-16 shrink-0" />
    </div>
  </header>

  <!-- Main content -->
  <main class="flex-1">
    <div class="max-w-4xl mx-auto px-6 py-14 text-center">
      <h1 class="text-3xl md:text-4xl font-extrabold tracking-widest text-gray-900">{{ 'digitalDoorway.title' | translate }}</h1>
      <p class="mt-6 text-gray-700">
        {{ 'digitalDoorway.subtitle' | translate }}
      </p>
      <p class="mt-4 italic text-sky-700">{{ 'digitalDoorway.tagline' | translate }}</p>

      <div class="mt-10 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <div *ngFor="let usl of authorities" class="bg-white border-2 border-sky-500 rounded-xl p-6 flex flex-col items-center">
          <img [src]="usl.image" alt="Servizio Sanitario della Toscana" class="h-16 mb-4" />
          <div class="italic text-sky-700 font-medium text-center mb-4">{{ 'digitalDoorway.authorities.' + usl.id | translate }}</div>
          <a [href]="usl.url" class="w-full text-center rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-5 py-2">
            {{ 'digitalDoorway.accessButton' | translate }}
          </a>
        </div>
      </div>

      <div class="mt-6 grid grid-cols-1 sm:grid-cols-4 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        <div
          class="bg-white border-2 border-sky-500 rounded-xl p-6 flex flex-col items-center sm:col-start-2 sm:col-span-2 md:col-start-2 md:col-span-1"
        >
          <div class="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
            <fa-icon [icon]="faBook" class="text-3xl text-sky-600" aria-hidden="true"></fa-icon>
          </div>
          <a
            href="https://cat.eu.visitnow.org/practice/rtspdigitale/"
            class="w-full text-center rounded-lg bg-cyan-500 hover:bg-cyan-600 text-white font-semibold px-5 py-2"
          >
            {{ 'digitalDoorway.myVisits' | translate }}
          </a>
        </div>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="w-full mt-auto py-10 text-gray-600">
    <div class="max-w-4xl mx-auto px-6">
      <div class="flex justify-center gap-10 text-sm">
        <div class="flex items-center gap-2">
          <fa-icon [icon]="faGlobe" class="text-gray-500"></fa-icon>
          <span>{{ 'footer.language' | translate }}</span>
          <div class="inline-flex rounded-md overflow-hidden border border-gray-300 ml-2">
            <button (click)="switchLanguage('en')" class="px-2 py-1 hover:bg-gray-100">EN</button>
            <button (click)="switchLanguage('it')" class="px-2 py-1 hover:bg-gray-100">IT</button>
          </div>
        </div>
      </div>
      <p class="text-center text-xs mt-6">&copy; 2025 Sigmasoft. {{ 'footer.rights' | translate }}</p>
    </div>
  </footer>
</div>
